import { useEffect, type ReactNode } from 'react'

export function AuthLayout({ title, children }: { title: string; children: ReactNode }) {
  useEffect(() => {
    document.title = `${title} · Briary Hub`
  }, [title])
  return (
    <div className="auth">
      <aside className="auth-brand">
        <img src="/brand/briary-logo-white.png" alt="Briary" />
        <div>
          <h1>Everything a plot needs, in one place.</h1>
          <p>Projects, SAP, site photos, air tests, EPCs and invoices. One sign-in for the Briary team, our clients and partners.</p>
        </div>
        <div className="foot">Briary Energy · Briary Hub</div>
        <svg className="leaf" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="0.6" aria-hidden="true">
          <path d="M5 21c0-9 5-15 15-17-1 10-7 15-15 17zM5 21l8-8" />
        </svg>
      </aside>
      <main className="auth-main">
        <div className="auth-card">{children}</div>
      </main>
    </div>
  )
}
